import React from 'react';
import { Box, Grid, Card, CardContent, Typography, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import PageTemplate from 'src/components/PageTemplate';
import { PATHS } from 'src/constants/config';
import { useDecodedToken } from 'src/hooks/useDecodedToken';
import toolsItems from 'src/utils/collections/toolsItems';

const Tools = () => {
  const navigate = useNavigate();
  const { isDemo } = useDecodedToken();

  const displayedToolsItems = toolsItems.filter((item) => {
    if (isDemo && (item.path === PATHS.MANAGE_OUTLETS.value || item.path === PATHS.MANAGE_KEYWORDS.value)) {
      return false;
    }
    return true;
  });

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <PageTemplate loading={false} title="Tools">
      <Box sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {displayedToolsItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Grid item xs={12} sm={6} md={3} key={item.path}>
                <Card
                  sx={{
                    height: '100%',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    border: '1px solid #e0e0e0',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
                      borderColor: 'primary.main',
                    },
                  }}
                  onClick={() => handleCardClick(item.path)}
                >
                  <CardContent
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      p: 4,
                      '&:last-child': { pb: 4 },
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 64,
                        height: 64,
                        bgcolor: 'primary.main',
                        mb: 2,
                      }}
                    >
                      <IconComponent sx={{ fontSize: 32, color: 'white' }} />
                    </Avatar>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        color: '#333',
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        lineHeight: 1.4,
                      }}
                    >
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </PageTemplate>
  );
};

export default Tools;
